<template>
  <div class="formulario h2-defaultMuni" @keyup.enter="aplicarFiltro">
    <div class="input-wrapper">
      <SearchableSelect
        :options="munis"
        :disabledItems="[muniSender]"
        :filter-keys="['firstname', 'lastname']"
        :selected="muniSender"
        :useLastAsPlaceholder="true"
        placeholderKey="firstname"
        defaultPlaceholder="Agente generador"
        @select="(v) => (muniSender = v)"
        :overlayDropdown="true"
      >
        <template #default="{ option }">
          <div class="status-item-container">
            <span class="h3-heroMuni"
              >{{ option.firstname }} {{ option.lastname }}</span
            >
          </div>
        </template>
      </SearchableSelect>
      <span v-if="muniSender" @click="muniSender = null" class="clear-button"
        >&times;</span
      >
    </div>

    <div class="input-wrapper">
      <SearchableSelect
        :options="munis"
        :disabledItems="[muni]"
        :filter-keys="['firstname', 'lastname']"
        :selected="muni"
        :useLastAsPlaceholder="true"
        placeholderKey="firstname"
        defaultPlaceholder="Agente asignado"
        @select="(v) => (muni = v)"
        :overlayDropdown="true"
      >
        <template #default="{ option }">
          <div class="status-item-container">
            <span class="h3-heroMuni"
              >{{ option.firstname }} {{ option.lastname }}</span
            >
          </div>
        </template>
      </SearchableSelect>
      <span v-if="muni" @click="muni = null" class="clear-button">&times;</span>
    </div>

    <div class="input-wrapper">
      <SearchableSelect
        :disabledItems="[user]"
        :searchFunction="UserHandler.searchByQuery"
        :selected="user"
        :useLastAsPlaceholder="true"
        :placeholderKey="['firstname', 'lastname']"
        defaultPlaceholder="Nombre o Cuil del Vecino"
        @select="(v) => (user = v)"
        :overlayDropdown="true"
      >
        <template #default="{ option }">
          <div class="status-item-container">
            <span class="h3-heroMuni"
              >{{ option.firstname }} {{ option.lastname }}</span
            >
          </div>
        </template>
      </SearchableSelect>
      <span v-if="user" @click="user = null" class="clear-button">&times;</span>
    </div>

    <div class="input-wrapper">
      <PickadayComponent
        v-model="fechasSeleccionadas"
        :maxDate="new Date()"
        :isMobile="true"
      />
      <span
        v-if="fechasSeleccionadas.length > 0"
        @click="fechasSeleccionadas = []"
        class="clear-button"
        >&times;</span
      >
    </div>

    <div class="input-wrapper">
      <SearchableSelect
        :options="taskStatuses"
        :disabledItems="[taskStatus]"
        :filter-keys="['title']"
        :selected="taskStatus"
        :useLastAsPlaceholder="true"
        placeholderKey="title"
        defaultPlaceholder="Estado"
        @select="(v) => (taskStatus = v)"
        :overlayDropdown="true"
      >
        <template #default="{ option }">
          <div class="status-item-container">
            <div
              class="status-circle"
              :style="{ backgroundColor: option.color }"
            ></div>
            <span class="h3-heroMuni">{{ option.title }}</span>
          </div>
        </template>
      </SearchableSelect>
      <span v-if="taskStatus" @click="taskStatus = ''" class="clear-button"
        >&times;</span
      >
    </div>

    <div class="input-wrapper">
      <input v-model="numeroTarea" placeholder="Número de la tarea" />
      <span v-if="numeroTarea" @click="numeroTarea = ''" class="clear-button"
        >&times;</span
      >
    </div>

    <div class="input-wrapper">
      <input v-model="title" placeholder="Nombre de la tarea" />
      <span v-if="title" @click="title = ''" class="clear-button">&times;</span>
    </div>

    <div class="btnsSection">
      <button @click="aplicarFiltro" class="actionBtn success h2-heroMuni">
        Aplicar
      </button>
      <button @click="limpiarFiltro" class="actionBtn error h2-heroMuni">
        Limpiar
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import PickadayComponent from "@/components/Utils/PickadayComponent.vue";
// import SearchableSelect from "@/components/Utils/SearchableSelect.vue";
import { useRouter } from "vue-router";
import { SearchableSelect } from "procedures-engine";
import UserHandler from "@/services/handlers/UserHandler";

const props = defineProps({
  munis: { type: Array, default: () => [] },
});
const emit = defineEmits(["close-modal"]);
const store = useStore();
const router = useRouter();

const taskStatus = ref(null);
const numeroTarea = ref("");
const fechasSeleccionadas = ref([]);
const muni = ref(null);
const muniSender = ref(null);
const user = ref(null);
const title = ref("");

const taskStatuses = ref([
  { value: "PENDIENTE", title: "Pendiente", color: "var(--color-success)" },
  {
    value: "FUERA DE PLAZO",
    title: "Fuera de Plazo",
    color: "var(--color-error)",
  },
  { value: "FINALIZADA", title: "Finalizada", color: "var(--text-muted)" },
]);

const loadFiltersFromStore = async () => {
  const filters = store.state.filters["tareas"] || {};

  taskStatus.value = filters.taskStatus
    ? (taskStatuses.value.find((t) => t.value === filters.taskStatus) ?? null)
    : null;
  numeroTarea.value = filters.taskId ?? "";
  title.value = filters.title ?? "";

  fechasSeleccionadas.value = [];
  if (filters.fromDate) fechasSeleccionadas.value[0] = filters.fromDate;
  if (filters.toDate) fechasSeleccionadas.value[1] = filters.toDate;

  muni.value = filters.userMuni
    ? (props.munis?.find((m) => m.id === filters.userMuni) ?? null)
    : null;
  muniSender.value = filters.muniSender
    ? (props.munis?.find((m) => m.id === filters.muniSender) ?? null)
    : null;
  user.value = null;
  if (filters.userId) {
    try {
      const foundUsers = await UserHandler.searchByQuery(
        filters.userId.toString(),
      );
      if (foundUsers && foundUsers.length > 0) {
        user.value = foundUsers.find((u) => u.id == filters.userId) || null;
      }
    } catch (error) {
      console.error("Error hidratando usuario:", error);
    }
  }
};

onMounted(() => loadFiltersFromStore());

function aplicarFiltro() {
  const condiciones = {};
  if (numeroTarea.value) condiciones.taskId = parseInt(numeroTarea.value);
  if (title.value) condiciones.title = title.value;
  if (fechasSeleccionadas.value[0])
    condiciones.fromDate = fechasSeleccionadas.value[0];
  if (fechasSeleccionadas.value[1])
    condiciones.toDate = fechasSeleccionadas.value[1];
  if (muni.value) condiciones.userMuni = muni.value.id;
  if (muniSender.value) condiciones.muniSender = muniSender.value.id;
  if (taskStatus.value) condiciones.taskStatus = taskStatus.value.value;
  if (user.value) condiciones.userId = user.value.id;

  if (Object.keys(condiciones).length === 0) return;

  if (document.activeElement) {
    document.activeElement.blur(); //quita foco del input
  }
  store.dispatch("setFiltersAction", { seccion: "tareas", condiciones });
  router.push({ name: "tareas" });
  emit("close-modal");
}

function limpiarFiltro() {
  taskStatus.value = null;
  numeroTarea.value = "";
  title.value = "";
  fechasSeleccionadas.value = [];
  muni.value = null;
  muniSender.value = null;
  store.dispatch("clearFiltersAction", "tareas");
  emit("close-modal");
}

watch(
  [() => props],
  () => {
    loadFiltersFromStore();
  },
  { deep: true },
);
</script>
<style>
/* variantes */
.actionBtn.success {
  background-color: var(--color-success);
}

.actionBtn.error {
  background-color: var(--color-error);
}
</style>
